import { Styles, css, withStyles } from '@recruit-robin/robin-theme/web-styles';

const styles = {
  root: css`
    display: flex;
    flex-direction: column;
    width: 506px;
    gap: 16px;
  `,
  buttons: css`
    display: flex;
    flex: 1 1 100%;
    align-items: center;
    justify-content: flex-end;
    gap: 12px;
  `,
} satisfies Styles<void>;

export const useStyles = withStyles(styles);
